import css from 'styled-jsx/css';
import Theme, { colors, fontSizes } from '../../themes';

const { borderRadius } = Theme.global;

export const inlineStyles = {
  button: { margin: '5px 0 3px' },
  buttonIcon: { marginLeft: 2, verticalAlign: 'baseline' },
  photosIcon: { marginRight: 5, position: 'relative', top: -1 },
};

export default css`
  .featured-snippet {
    padding: 0 6px 0;
    background: ${colors.grayExtraLight};
  }

  a {
    display: block;
    background: #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    color: #757575;
    overflow: hidden;
    position: relative;
    -webkit-text-decoration: none;
    text-decoration: none;
  }

  h2 {
    color: ${colors.grayDeep};
    font-size: 1.1rem;
    font-weight: bold;
    line-height: 1.15;
    margin: 0 0 13px;
    max-height: 40px;
    overflow: hidden;
  }

  .featured-snippet .visited h2 {
    color: ${colors.purpleLight};
  }

  .featured-snippet .content {
    padding: 12px;
  }

  .featured-snippet :global(.img) {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    width: 100%;
    height: 270px;
    background: ${colors.grayExtraLight};
  }

  @media (max-width: 350px) {
    .featured-snippet :global(.img) {
      height: 225px;
    }
  }

  .featured-snippet .placeholder {
    background: ${colors.grayExtraLight};
    color: ${colors.grayLight};
    display: block;
    height: 100%;
    width: 100%;
  }

  .featured-snippet .placeholder span {
    left: 50%;
    position: absolute;
    top: 50%;
    margin: -25px 0 0 -25px;
  }

  .featured-snippet :global(.photos) {
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    border-radius: ${borderRadius};
    font-size: ${fontSizes.small};
    padding: 4px 6px;
    position: absolute;
    left: 5px;
    bottom: 5px;
  }

  .featured-snippet :global(.new) {
    background: ${colors.orange};
    font-size: ${fontSizes.small};
    color: #fff;
    padding: 6px 7px;
    position: absolute;
    right: 5px;
    top: 5px;
    border-radius: 6px;
    text-transform: uppercase;
    margin: 0;
    font-weight: bold;
  }

  .middle-info :global(.features) {
    padding: 0;
    margin: 0;
  }

  .middle-info :global(.features-wrapper) {
    display: block;
    height: 30px;
  }

  .featured-snippet :global(.location svg) {
    fill: ${colors.grayDark} !important;
    color: ${colors.grayDark} !important;
    width: 15px !important;
    margin-top: -3px;
    height: 20px;
  }

  :global(.rtl) .featured-snippet :global(.new) {
    right: auto;
    left: 5px;
  }

  .featured-snippet :global(.location .text) {
    font-size: ${fontSizes.normal};
  }

  .featured-snippet :global(.img > .image-wrapper) {
    width: 100%;
    height: auto;
    top: 50%;
    left: auto;
    position: absolute;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .featured-snippet .middle-info {
    margin-top: 0.7rem;
    display: flex;
    justify-content: space-between;
  }

  .featured-snippet .middle-info :global(.price) {
    font-weight: 600;
    margin: 3px 0;
  }

  .middle-info .noPrice {
    font-size: ${fontSizes.normal};
    margin: 5px 0;
  }

  .middle-info :global(.features .value) {
    font-size: ${fontSizes.normal};
    color: #424242;
  }

  .middle-info :global(.features .name) {
    font-size: ${fontSizes.small};
  }

  .bottom-info {
    margin-top: 1rem;
  }

  .bottom-info .source-label {
    color: ${colors.blue};
    background: ${colors.blueExtraLight};
    font-size: ${fontSizes.normal};
    border-radius: 5rem;
    padding: 0.3rem 0.5rem;
  }

  .bottom-info .date {
    font-size: ${fontSizes.normal};
    overflow: hidden;
    margin-right: 15px;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }

  .bottom-info .date::first-letter {
    text-transform: capitalize;
  }
`;



// WEBPACK FOOTER //
// ./app/FeaturedAd/shared/styles.js